module.exports = __webpack_public_path__ + "static/media/23.980e7881.jpg";